import { BASE_URL } from '@/shared/lib/const/env'
import { TProductVideo } from '@/shared/types/product-types'

export type ProductSliderMedia = {
	type: 'image' | 'video'
	src: string
	poster?: string
}

const ABSOLUTE_URL_REGEXP = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i

const getProductVideoMedia = (videos?: TProductVideo[] | null): ProductSliderMedia[] =>
	(videos || []).reduce<ProductSliderMedia[]>((acc, video) => {
		if (typeof video === 'string') {
			acc.push({ type: 'video', src: video })
			return acc
		}

		if (video.SRC) {
			acc.push({ type: 'video', src: video.SRC, poster: video.POSTER || undefined })
		}

		return acc
	}, [])

export const getProductSliderMedia = (
	images?: string[] | null,
	videos?: TProductVideo[] | null
): ProductSliderMedia[] => [
	...(images || []).map(src => ({ type: 'image' as const, src })),
	...getProductVideoMedia(videos)
]

export const getMediaUrl = (src: string): string => (ABSOLUTE_URL_REGEXP.test(src) ? src : `${BASE_URL}${src}`)
